import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IPayment } from 'app/interface/IPayment'

import { initialPayment } from '../initialState'

const paymentSlice = createSlice({
  name: 'payment',
  initialState: initialPayment,
  reducers: {
    updatePaymentInfo: (state: IPayment, action: PayloadAction<IPayment>): IPayment => action.payload,
  },
})
export const paymentAction = paymentSlice.actions
export default paymentSlice
